// components/HelpModal/LeitnerTab.jsx
import React from "react";
import "./LeitnerTab.css";

const LeitnerTab = () => {
  return (
    <div className="leitner-tab">
      {/* توضیحات کلی لایتنر */}
      <div className="leitner-intro">
        <div className="leitner-intro-header">
          <span className="leitner-intro-icon">📖</span>
          <h3>لایتنر چیست و چه مزایایی دارد؟</h3>
        </div>
        <div className="leitner-intro-content">
          <p>
            لایتنر یک روش علمی و اثبات‌شده برای یادگیری و به‌خاطر سپردن بلندمدت
            لغات است که بر پایه{" "}
            <strong>
              تکرار با فاصله زمانی افزایش‌یابنده (Spaced Repetition System -
              SRS)
            </strong>{" "}
            کار می‌کند.
          </p>
          <div className="leitner-benefits">
            <h4>✨ مزایای استفاده از لایتنر:</h4>
            <div className="leitner-benefit-item">
              <span className="leitner-benefit-icon">🧠</span>
              <div>
                <strong>افزایش ماندگاری در حافظه بلندمدت:</strong>
                <p>
                  لغات را دقیقاً در زمانی که در آستانه فراموشی هستند مرور
                  می‌کنید
                </p>
              </div>
            </div>
            <div className="leitner-benefit-item">
              <span className="leitner-benefit-icon">⏱️</span>
              <div>
                <strong>صرفه‌جویی در زمان:</strong>
                <p>فقط لغاتی که نیاز به مرور دارند نمایش داده می‌شوند</p>
              </div>
            </div>
            <div className="leitner-benefit-item">
              <span className="leitner-benefit-icon">📊</span>
              <div>
                <strong>یادگیری هدفمند:</strong>
                <p>لغات سخت‌تر بیشتر و لغات آسان‌تر کمتر تکرار می‌شوند</p>
              </div>
            </div>
            <div className="leitner-benefit-item">
              <span className="leitner-benefit-icon">🎯</span>
              <div>
                <strong>پیگیری پیشرفت:</strong>
                <p>می‌توانید روند یادگیری خود را مشاهده و پیگیری کنید</p>
              </div>
            </div>
          </div>

          {/* نحوه کار کلی - گسترش یافته */}
          <div className="leitner-how-it-works">
            <h4>🔄 نحوه کار لایتنر و متد تکرار با فاصله (SRS) چگونه است؟</h4>

            <div className="leitner-theory">
              <h5>
                <span className="leitner-theory-icon">🔬</span>
                پایه علمی: منحنی فراموشی ابینگهاوس
              </h5>
              <p>
                هرمان ابینگهاوس، روان‌شناس آلمانی، در قرن نوزدهم کشف کرد که
                انسان‌ها اطلاعات جدید را با الگویی قابل پیش‌بینی فراموش می‌کنند.
                او "منحنی فراموشی" را رسم کرد که نشان می‌دهد:
              </p>
              <div className="leitner-forgetting-curve">
                <div className="leitner-curve-item">
                  <span className="curve-badge danger">📉 ۲۰ دقیقه</span>
                  <span>حدود ۴۲٪ اطلاعات فراموش می‌شود</span>
                </div>
                <div className="leitner-curve-item">
                  <span className="curve-badge warning">📉 ۱ ساعت</span>
                  <span>حدود ۵۶٪ اطلاعات فراموش می‌شود</span>
                </div>
                <div className="leitner-curve-item">
                  <span className="curve-badge info">📉 ۱ روز</span>
                  <span>حدود ۶۷٪ اطلاعات فراموش می‌شود</span>
                </div>
                <div className="leitner-curve-item">
                  <span className="curve-badge success">📉 ۱ ماه</span>
                  <span>حدود ۷۹٪ اطلاعات فراموش می‌شود</span>
                </div>
              </div>
              <p className="leitner-key-insight">
                <strong>💡 نکته طلایی:</strong> اگر درست قبل از فراموشی، مطلب را
                مرور کنیم، منحنی فراموشی "بازنشانی" می‌شود و این بار
                <strong> دیرتر</strong> فراموش می‌کنیم. این دقیقاً کاری است که
                لایتنر انجام می‌دهد!
              </p>
            </div>

            {/* <div className="leitner-mechanism">
              <h5>
                <span className="leitner-theory-icon">⚙️</span>
                مکانیزم جعبه‌های لایتنر
              </h5>
              <p>
                در سیستم لایتنر، لغات در چند جعبه (معمولاً ۵ جعبه) طبقه‌بندی
                می‌شوند. هر جعبه نشان‌دهنده میزان تسلط شما بر آن لغت است
              </p>

              <div className="leitner-boxes">
                <div className="leitner-box-item box-1">
                  <div className="leitner-box-header">
                    <span className="leitner-box-number">جعبه ۱</span>
                    <span className="leitner-box-interval">⏰ هر روز</span>
                  </div>
                  <p className="leitner-box-desc">
                    لغات جدید یا لغاتی که در مرور قبلی اشتباه پاسخ داده‌اید.
                    <strong>هر روز</strong> باید مرور شوند.
                  </p>
                </div>

                <div className="leitner-box-item box-2">
                  <div className="leitner-box-header">
                    <span className="leitner-box-number">جعبه ۲</span>
                    <span className="leitner-box-interval">⏰ هر ۲ روز</span>
                  </div>
                  <p className="leitner-box-desc">
                    لغاتی که یک بار درست پاسخ داده‌اید. فاصله مرور کمی بیشتر
                    می‌شود.
                  </p>
                </div>

                <div className="leitner-box-item box-3">
                  <div className="leitner-box-header">
                    <span className="leitner-box-number">جعبه ۳</span>
                    <span className="leitner-box-interval">⏰ هر ۴ روز</span>
                  </div>
                  <p className="leitner-box-desc">
                    لغاتی که دو بار متوالی درست پاسخ داده‌اید. حافظه شما در حال
                    تثبیت است.
                  </p>
                </div>

                <div className="leitner-box-item box-4">
                  <div className="leitner-box-header">
                    <span className="leitner-box-number">جعبه ۴</span>
                    <span className="leitner-box-interval">⏰ هر ۸ روز</span>
                  </div>
                  <p className="leitner-box-desc">
                    لغاتی که سه بار درست پاسخ داده‌اید. نشانه تسلط خوب.
                  </p>
                </div>

                <div className="leitner-box-item box-5">
                  <div className="leitner-box-header">
                    <span className="leitner-box-number">جعبه ۵</span>
                    <span className="leitner-box-interval">⏰ هر ۱۶ روز</span>
                  </div>
                  <p className="leitner-box-desc">
                    لغاتی که کاملاً مسلط هستید. وارد حافظه بلندمدت شده‌اند.
                  </p>
                </div>
              </div>

              <div className="leitner-rules">
                <h5>
                  <span className="leitner-theory-icon">📋</span>
                  قوانین حرکت بین جعبه‌ها:
                </h5>
                <div className="leitner-rule-item success-rule">
                  <span className="rule-icon">✅</span>
                  <div>
                    <strong>پاسخ درست:</strong>
                    <p>
                      لغت به جعبه بعدی ارتقا می‌یابد. هر چه جلوتر می‌روید، فاصله
                      مرور بیشتر می‌شود چون مغز شما آن لغت را بهتر به خاطر
                      می‌سپارد.
                    </p>
                  </div>
                </div>
                <div className="leitner-rule-item danger-rule">
                  <span className="rule-icon">❌</span>
                  <div>
                    <strong>پاسخ اشتباه:</strong>
                    <p>
                      لغت به جعبه ۱ برمی‌گردد (یا یک جعبه عقب می‌رود). این یعنی
                      لغت هنوز در حافظه تثبیت نشده و نیاز به مرور بیشتری دارد.
                    </p>
                  </div>
                </div>
              </div>
            </div>

            <div className="leitner-example">
              <h5>
                <span className="leitner-theory-icon">🎮</span>
                یک مثال عملی:
              </h5>
              <div className="leitner-timeline">
                <div className="leitner-timeline-item">
                  <div className="timeline-day">روز ۱</div>
                  <p>
                    لغت "Ephemeral" را می‌بینید و یاد می‌گیرید (جعبه ۱).
                    <br />
                    <small>معنی: زودگذر، ناپایدار</small>
                  </p>
                </div>
                <div className="leitner-timeline-item">
                  <div className="timeline-day">روز ۲ (فردا)</div>
                  <p>
                    دوباره ظاهر می‌شود. اگر درست پاسخ دهید ← جعبه ۲
                    <br />
                    <small>مرور بعدی: ۲ روز دیگر</small>
                  </p>
                </div>
                <div className="leitner-timeline-item">
                  <div className="timeline-day">روز ۴</div>
                  <p>
                    اگر باز هم درست پاسخ دهید ← جعبه ۳
                    <br />
                    <small>مرور بعدی: ۴ روز دیگر</small>
                  </p>
                </div>
                <div className="leitner-timeline-item">
                  <div className="timeline-day">روز ۸</div>
                  <p>
                    اگر اینجا اشتباه کنید ← برمی‌گردد به جعبه ۱!
                    <br />
                    <small>
                      یعنی هر روز باید مرور شود تا دوباره مسیر را طی کند
                    </small>
                  </p>
                </div>
              </div>
              <p className="leitner-conclusion">
                <strong>🎯 نتیجه:</strong> این سیستم باعث می‌شود لغاتی که
                برایتان سخت‌تر هستند <strong>بیشتر و زودتر</strong> تکرار شوند و
                لغاتی که به راحتی یاد گرفته‌اید <strong>کمتر و با فاصله</strong>{" "}
                مرور شوند. این یعنی استفاده بهینه از زمان و انرژی شما!
              </p>
            </div> */}
          </div>
        </div>
      </div>

      {/* مراحل انتقال لغات */}
      <div className="leitner-section">
        <div className="leitner-section-header">
          <span className="leitner-step-badge">مرحله ۱</span>
          <h3>مراحل انتقال لغات ذخیره شده به لایتنر</h3>
        </div>
        <div className="leitner-steps">
          <div className="leitner-step-item">
            <div className="leitner-step-number">۱</div>
            <div className="leitner-step-content">
              <p>
                ابتدا با کلیک بر روی <strong>ساخت جعبه لایتنر</strong> یک جعبه
                جدید می‌سازیم
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۲</div>
            <div className="leitner-step-content">
              <p>
                بر روی دکمه <strong>انتقال لغات به لایتنر</strong> کلیک کنید
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۳</div>
            <div className="leitner-step-content">
              <p>
                زبان اول و ترجمه لغات را مشخص کرده و بر روی{" "}
                <strong>بررسی</strong> کلیک کنید تا لیست لغات انتخاب شده نمایش
                داده شود
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۴</div>
            <div className="leitner-step-content">
              <p>جعبه لایتنر مقصد را انتخاب کنید</p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۵</div>
            <div className="leitner-step-content">
              <p>
                بر روی <strong>انتقال لغات به لایتنر</strong> کلیک کنید تا
                فرایند انتقال انجام شود
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* مراحل مرور لغات */}
      <div className="leitner-section">
        <div className="leitner-section-header">
          <span className="leitner-step-badge">مرحله ۲</span>
          <h3>نحوه مرور و یادگیری لغات</h3>
        </div>
        <div className="leitner-steps">
          <div className="leitner-step-item">
            <div className="leitner-step-number">۱</div>
            <div className="leitner-step-content">
              <p>
                با کلیک بر روی <strong>جزئیات و مرور</strong> لایتنر مورد نظر
                خود را انتخاب کنید
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۲</div>
            <div className="leitner-step-content">
              <p>
                در صفحه باز شده تعداد لغات آماده مرور به شما نمایش داده می‌شود و
                با کلیک بر روی <strong>شروع مرور</strong> فرایند یادگیری را آغاز
                کنید
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۳</div>
            <div className="leitner-step-content">
              <p>
                لغت به شما نمایش داده می‌شود و شما باید ترجمه آن را حدس بزنید و
                سپس بر روی <strong>مشاهده نمایش پاسخ</strong> کلیک کنید
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۴</div>
            <div className="leitner-step-content">
              <p>
                با توجه اینکه تا چه میزان ترجمه لغت را درست گفته‌اید باید انتخاب
                کنید لغت تا چه زمانی دیگر به شما نمایش داده نشود
              </p>
            </div>
          </div>
          <div className="leitner-step-item">
            <div className="leitner-step-number">۵</div>
            <div className="leitner-step-content">
              <p>
                پس از تعیین وضعیت کارت فعلی، کارت بعدی به شما نشان داده می‌شود و
                شما باید این فرایند را تا اتمام کارت‌ها ادامه دهید
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* ویدئوی آموزشی */}
      {/* <div className="leitner-video-section">
        <div className="leitner-video-card">
          <div className="leitner-video-icon">🎬</div>
          <h4>ویدئوی آموزش کار با لایتنر</h4>
          <p>برای مشاهده آموزش تصویری کار با لایتنر روی لینک زیر کلیک کنید</p>
          <a
            href="https://app.umlang.com"
            target="_blank"
            rel="noopener noreferrer"
            className="leitner-video-link"
          >
            <i className="fas fa-play-circle"></i>
            کلیک کنید
          </a>
        </div>
      </div> */}
    </div>
  );
};

export default LeitnerTab;
